export default __webpack_public_path__ + "static/media/LC_PP.b3e9b10a.png";